/**
 * Switchable - jQuery plugin to create a simple iOS style switcher for checkboxes.
 * Copyright (c) 2014, Rogério Taques.
 *
 * Licensed under MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this
 * software and associated documentation files (the "Software"), to deal in the Software
 * without restriction, including without limitation the rights to use, copy, modify, merge,
 * publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons
 * to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or
 * substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING
 * BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * @requires jQuery v1.9 or above
 * @version 1.2
 * @cat Plugins/Form Validation
 * @author Rogério Taques (rogerio.taques@gmail.com)
 * @author Bruno Buiret <bruno.b@apps-panel.com>
 * @see https://github.com/rogeriotaques/switchable
 */

/**
 * CHANGELOG
 *
 * 1.0 First release.
 *       Supports label position (after/before), custom checked color and readonly property.
 * 1.1 Second release
 *     Minor bug fixes
 * 1.2 Customization needed by Apps Panel
 *     Added mutation observers on the checkboxes' attributes to mirror the actual state whenever they aren't manipulated
 *     via switchable.
 *     Also, added class "switchable-disabled" to allow customization for this state.
 *     Finally, a check is performed on the checkbox so as not to change its state if it is disabled.
 */
(function ($) {
    var version = '1.0.1',
        // default options
        defaults = {
            // define the label position
            // possible values are 'before' (default) and 'after'
            label_position: 'before',
            // a custom color for the switch when checked
            // default is null, but you can provide following pattern:
            //    #FFF, rgb(255,255,255), rgba(255,255,255, 0.5) or white
            checked_color: null,
            // indicates wheter the widget is readonly
            // possible values: true/false. default is false.
            readonly: false,
            // on click callback
            // function parameters are: event, boolean (that indicates if it's checked)
            click: null
        },
        methods = {
            version: function () {
                return this.each(function () {
                    $(this).html(version);
                });
            }, // version
            init: function (options) {
                var o = $.extend(defaults, options);

                return this.each(function () {
                    var me = $(this),
                        wrapper = $('<div />', {'class': 'switchable-wrapper'}),
                        switcher = $('<div />', {'class': 'switchable-holder', 'style': 'display: inline-block'}),
                        button = $('<div />', {'class': 'switchable-switcher'}),
                        label = $('<div />', {
                            'class': 'switchable-label',
                            'html': (me.data('label') ? me.data('label') : '')
                        }),
                        // Toggle switchable's class whenever input's attribute "disabled" is updated
                        observer = new MutationObserver(function (mutations) {
                            for (var i = 0; i < mutations.length; i++) {
                                switcher.toggleClass('switchable-' + mutations[i].attributeName, me.prop(mutations[i].attributeName));
                            }
                        })
                    ;

                    observer.observe(this, {attributes: true, attributeFilter: ['disabled']});

                    button.appendTo(switcher.appendTo(wrapper));
                    me.after(wrapper);

                    if (me.data('label')) {
                        if ('before' === o.label_position) {
                            switcher.before(label);
                        }
                        else {
                            wrapper.append(label);
                        }
                    }

                    me.hide();
                    switcher.toggleClass('switchable-checked', me.prop('checked'));
                    switcher.toggleClass('switchable-disabled', me.prop('disabled'));

                    // when a custom checked_color is given
                    // force to use this color instead of the default one
                    if (o.checked_color) {
                        _setCustomColor(switcher, me.is(':checked'), o);
                    }

                    if (!o.readonly) {
                        button.on('click', function (e) {
                            if (!me.prop('disabled')) {
                                me.prop('checked', !me.is(':checked'));
                                switcher.toggleClass('switchable-checked', me.is(':checked'));

                                // when a custom checked_color is given
                                // force to use this color instead of the default one
                                if (o.checked_color) {
                                    _setCustomColor(switcher, me.is(':checked'), o);
                                }

                                if (o.click && $.isFunction(o.click)) {
                                    e.switcher = me;
                                    return o.click(e, me.is(':checked'));
                                }
                                // Trigger default change event if no click handler has been defined
                                // Bruno Buiret <bruno.b@apps-panel.com>
                                else {
                                    me.trigger('change');
                                }
                            }
                        });
                    }
                    else {
                        switcher.addClass('switchable-readonly');
                    }

                }); // this.each
            }, // init
            checked: function(checked) {
                return this.each(function() {
                    var $input = $(this);

                    $input
                        .prop('checked', checked)
                        .next('.switchable-wrapper')
                        .find('.switchable-holder')
                        .toggleClass('switchable-checked', checked)
                    ;
                }); // this.each
            } // checked
        }; // methods

    function _setCustomColor(switcher, is_checked, options) {

        switcher.css({
            'border-color': (is_checked ? options.checked_color : ''),
            'background-color': (is_checked ? options.checked_color : '')
        });

    } // _setCustomColor

    $.fn.switchable = function (method) {
        if (methods[method]) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof method === 'object' || !method) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + method + ' does not exist on jQuery.Switchable()');
        }
    };
})(jQuery);